import React from 'react';
import PropTypes from 'prop-types';

class Tab extends React.Component {

  static propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node,
  }

  activeClassName = 'is-active'

  render() {
    const { active } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;
    const children = this.props.children || [];
    return (
      <div className={className}>
        {children}
      </div>
    );
  }
}

export default Tab;
